export const gitCommit = '8b03450d'
